import React, { Component } from 'react'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import { change } from 'redux-form'
import { connect } from 'react-redux'

class ItemRelationField extends Component {

  render () {
    let {formValues, disabled} = this.props
    return <DropdownButton title={formValues && formValues.relation} disabled={disabled}>
      <MenuItem eventKey='1' onSelect={(e) => { this._handleChangeRelation(e) }}>AND</MenuItem>
      <MenuItem eventKey='2' onSelect={(e) => { this._handleChangeRelation(e) }}>OR</MenuItem>
    </DropdownButton>
  }

  _handleChangeRelation = (e) => {
    let {formName, fieldName} = this.props
    let relation
    switch (e) {
      case '1':
        relation = 'AND'
        break
      case '2':
        relation = 'OR'
        break
    }
    this.props.dispatch(change(formName, fieldName, relation))
  }
}

ItemRelationField.propTypes = {
  formValues: React.PropTypes.object,
  formName: React.PropTypes.string,
  fieldName: React.PropTypes.string
}

export default connect()(ItemRelationField)



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/ItemRelationField/ItemRelationField.js